<template>
  <div class="Closures">
    <div class="reportBasic-subTitle">
      {{ $tc('lang.FabricReport.DEFECTIVES_LIST') }}
    </div>
    <div class="desOfGoods-con">
      <span>{{ $tc('lang.FabricReport.DEFECTIVES_LIST') }}</span>
      <div class="img">
        <show-img
          :data="closures.fmediaFourpointsystem"
          :otherData="{
            mediaName: '四分制表格',
            mediaType: 3,
            personId: '',
            orderId: '',
            reportId: '',
            mediaDesc: 'fmediaFourpointsystem',
          }"
          :id="id"
        ></show-img>
      </div>
      <!-- <div class="button-group">
        <a-button
          type="primary"
          size="small"
          @click="
            saveImg(closures.fmediaFourpointsystem, 'fmediaFourpointsystem')
          "
          >保存</a-button
        >
      </div> -->
    </div>
  </div>
</template>
<script>
import showImg from './showImg';

export default {
  data() {
    return {
      id: this.$route.query.id,
    };
  },
  computed: {
    fabricDetails: {
      get() {
        return JSON.parse(
          JSON.stringify(this.$store.state.report.fabricDetails),
        );
      },
    },
    closures: {
      get() {
        return JSON.parse(
          JSON.stringify(this.$store.state.report.fabricImgList.closures),
        );
      },
    },
  },
  components: {
    showImg,
  },
  created() {},
  methods: {
    //保存图片
    saveImg(data, type) {
      let fileList = [];
      data.forEach(item => {
        fileList.push(item.id);
      });
      let postData = {
        ireportId: this.fabricDetails.freportId,
        imediaName: '四分制表格',
        imediaSaveType: '1',
        modelType: '7',
      };
      postData[type] = fileList.join(',');
      this.$http
        .post('/hzwmj/fabric-media/saveOrUpdateFabricMedia', postData)
        .then(data => {
          if (data) {
            // this.visible = false;
            this.$message.success('保存成功');
            this.$store.dispatch(
              'report/getfabricImg',
              this.fabricDetails.freportId,
            );
          } else {
            this.$message.error('保存失败');
          }
        })
        .catch(() => {
          this.$message.error('保存失败');
        });
    },
  },
};
</script>
<style lang="less">
.Closures {
  .desOfGoods-con {
    display: flex;
    margin-top: 30px;
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
    .img {
      flex-grow: 1;
    }
    > span {
      display: inline-block;
      width: 100px;
      flex-shrink: 0;
      padding-left: 20px;
    }
  }
  .desOfGoods-table {
    display: flex;
    .desOfGoods-table2 {
      flex-grow: 1;
      margin-left: 20px;
    }
    .desOfGoods-table3 {
      flex-grow: 1;
      margin-left: 20px;
    }
    .button-group {
      width: 130px;
      flex-shrink: 0;
    }
  }
}
.reportModal1 {
  .updataForm {
    display: flex;
    .ant-form-item-label {
      text-align: left;
    }
    > div {
      width: 50%;
    }
    .title {
      width: 70%;
      text-align: center;
      margin-top: 5px;
      > button {
        margin-bottom: 3px;
      }
    }
    .part {
      width: 70%;
      padding-top: 10px;
      border-bottom: 1px dashed rgba(25, 21, 37, 0.28);
      display: flex;
      .ant-form-item-label {
        flex-shrink: 0;
      }
      .ant-row {
        margin-bottom: 10px;
      }
    }
  }
}
</style>
